import './Stepper.css';

import { ReactComponent as BoxIcon } from '../../assets/waitingForDelivery.svg';
import { ReactComponent as PorterIcon } from '../../assets/onPorter.svg';
import { ReactComponent as ClipboardIcon } from '../../assets/acceptGoods.svg';
import { ReactComponent as DeliveredIcon } from '../../assets/delivered.svg';

const Stepper = ({ activeStep, type }) => {

  let steps = []

  if (type === "StoreToMallLogistics") {
    steps = [
      { title: 'Teslim Bekleniyor', subtitle: 'Mağazada Bekliyor', Icon: BoxIcon },
      { title: 'Porter Zimmetinde', subtitle: 'Gönderi Porterde', Icon: PorterIcon },
      { title: 'Mal Kabulde', subtitle: 'Mal Kabule Teslim Edildi', Icon: ClipboardIcon },
      { title: 'Teslim Edildi', subtitle: 'Paket Teslim Edildi', Icon: DeliveredIcon },
    ];
  }
  else {
    steps = [
      { title: 'Mal Kabulde', subtitle: 'Mağazada Bekliyor', Icon: BoxIcon },
      { title: 'Porter Zimmetinde', subtitle: 'Gönderi Porterde', Icon: PorterIcon },
      { title: 'Teslim Edildi', subtitle: 'Mağazaya Ulaştı', Icon: DeliveredIcon },
    ];
  }

  return (
    <div className="stepper-container">
      <div className='stepper-inner-container'>

        {steps.map(({ title, subtitle, Icon }, index) => {
          const isCompleted = index < activeStep;
          const isActive = index === activeStep;
          return (
            <div
              key={index}
              className={[
                'step-item',
                isCompleted ? 'completed' : '',
                isActive ? 'active' : ''
              ].join(' ')}
            >
              <div className="step-icon">
                <Icon className="step-icon-svg" />
              </div>
              <div className="step-title">{title}</div>
              <div className="step-subtitle">{subtitle}</div>
              {index < steps.length - 1 && <div className="step-line"></div>}
            </div>
          );
        })}
      </div>

    </div>
  );
};

export default Stepper;
